import type { IconSvgObject } from './types';

const SquareArrowLeftRightIcon: IconSvgObject = [
  ["path", { d: "M21.5 4.50002V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.50002C2.5 3.39545 3.39543 2.50002 4.5 2.50002H19.5C20.6046 2.50002 21.5 3.39545 21.5 4.50002Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 9L8.50002 9M10 7L8 9L10 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 17L16 15L14 13M15.5 15L8 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SquareArrowLeftRightIcon;
